export default __webpack_public_path__ + "static/media/Gold.d5c4c7a7.png";